import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { GlobeIcon } from 'lucide-react';
export function LanguageSwitcher() {
  const {
    language,
    setLanguage
  } = useLanguage();
  return <div className="flex items-center gap-2" data-id="element-206">
      <GlobeIcon className="w-4 h-4 text-gray-400" data-id="element-207" />
      <button onClick={() => setLanguage('de')} className={`text-sm font-medium transition-colors ${language === 'de' ? 'text-white' : 'text-gray-400 hover:text-gray-300'}`} data-id="element-208">
        DE
      </button>
      <span className="text-gray-600" data-id="element-209">|</span>
      <button onClick={() => setLanguage('en')} className={`text-sm font-medium transition-colors ${language === 'en' ? 'text-white' : 'text-gray-400 hover:text-gray-300'}`} data-id="element-210">
        EN
      </button>
    </div>;
}